/**
 * Convierte el buffer a base64.
 *
 * @param {ArrayBuffer} buffer
 * @returns {string}
 */
const base64ToBrowser = (buffer) =>
  window.btoa(
    [].slice
      .call(new Uint8Array(buffer))
      .map((bin) => String.fromCharCode(bin))
      .join('')
  );

/**
 * Carga el binario de la url suministrada
 * y lo convierte a base64.
 *
 * @param {string} url
 * @returns {Promise<string>}
 */
const getBase64FromUrl = async (url) => {
  let base64 = null;
  try {
    const response = await fetch(url);
    const buffer = await response.arrayBuffer();
    base64 = base64ToBrowser(buffer);
  } catch (e) {
    console.error(e);
  }

  return base64;
};

export default getBase64FromUrl;
